import API from './api';

function _urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Devuelve true si el navegador soporta push y el permiso aun no esta concedido
// (es decir, conviene mostrar un aviso/boton para que el cliente lo active).
export function clientePushNecesario() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  if (typeof Notification === 'undefined') return false;
  return Notification.permission !== 'granted';
}

// Suscribe el dispositivo del CLIENTE (storefront) a notificaciones push web.
// DEBE llamarse desde un gesto del usuario (boton/aviso) porque Android/Chrome
// ignora requestPermission() fuera de un contexto de usuario.
// Requiere un session_id valido (cliente registrado). Devuelve true si suscribio.
export async function setupClientePush(schemaName, sessionId) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return false;
  if (!schemaName || !sessionId) return false;

  try {
    let permiso = Notification.permission;
    if (permiso === 'default') {
      permiso = await Notification.requestPermission();
    }
    if (permiso !== 'granted') return false;

    const reg = await navigator.serviceWorker.ready;
    const { data } = await API.get('/push-cliente/vapid-public-key');
    const key = data?.data?.vapid_public_key;
    if (!key) return false;

    let subscription = await reg.pushManager.getSubscription();
    if (!subscription) {
      subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: _urlBase64ToUint8Array(key),
      });
    }

    const json = subscription.toJSON();
    await API.post('/push-cliente/suscribir', {
      schema_name: schemaName,
      session_id: sessionId,
      endpoint: json.endpoint,
      keys: json.keys,
    });
    return true;
  } catch (e) {
    console.warn('No se pudo activar push del cliente:', e);
    return false;
  }
}
